import {
  collapsedStyles,
  getDesktopDefaultStyles,
  getDesktopSupportWindowStyles,
  getMobileDefaultStyles,
  getMobileSupportWindowStyles,
  GetStylesParams,
} from '../consts';
import { type DisplayModes } from '../types';

export const getDisplayModeToResponsiveStyles = (
  params: GetStylesParams
): Record<DisplayModes, Record<string, object>> => ({
  FAB: {
    desktop: { ...getDesktopDefaultStyles(params), ...collapsedStyles },
    mobile: { ...getMobileDefaultStyles(params), ...collapsedStyles },
  },
  WINDOW: {
    desktop: getDesktopSupportWindowStyles(params),
    mobile: getMobileSupportWindowStyles(),
  },
  HIDDEN: {
    desktop: { display: 'none' },
    mobile: { display: 'none' },
  },
});
